<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="50%"
      height="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>问卷数据统计</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row" type="flex" justify="end">
            <div class="option">
              <el-button @click="handleCancel" plain>
                <span>返回列表</span>
              </el-button>
              <el-button plain type="primary" @click="downloadReport">
                <span>下载报告</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all" ref="pdf">
            <!-- 表单区域-->
            <el-row class="title-row" type="flex" justify="center">
              <span class="title">{{title}}</span>
            </el-row>
            <div class="switch-content">
              <el-form size="small">
                <div class="formtable">
                  <div v-for="item in DataList" :key="item.id">
                    <el-row
                      :gutter="20"
                      class="row-bg"
                      v-if="
                        item.questionTopicType == 1 ||
                        item.questionTopicType == 0
                      "
                    >
                      <el-col :span="20">
                        <div class="grid-content bg-purple">
                          <el-form-item>
                            {{
                              "第" + item.number + "题：" + item.questionOption
                            }}
                            <span class="topictype" v-if="item.questionTopicType == 0">[单选题]</span>
                            <span class="topictype" v-else>[多选题]</span>
                          </el-form-item>
                          <el-form-item label="">
                            <vxe-table
                              :data="item.data1"
                              round
                              border
                              class="mytable-scrollbar"
                              style="width: 100%"
                              ref="multipleTable"
                              empty-text="没有更多数据了！"
                              resizable
                              stripe
                            >
                              <template
                                v-for="(item, key) in Data1List"
                                :key="key"
                              >
                                <vxe-table-column
                                  v-if="item.isShow && item.prop=='scale'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                >
                                <template #default="{ row, column }">
                                  <el-progress :percentage="row[column.property]" :color="customColorMethod"></el-progress>
                                  </template>
                                </vxe-table-column>
                                <vxe-table-column
                                  v-if="item.isShow && item.prop!='scale'"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                />
                              </template>
                            </vxe-table>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row
                      :gutter="20"
                      class="row-bg"
                      v-if="
                        item.questionTopicType == 2
                      "
                    >
                      <el-col :span="20">
                        <div class="grid-content bg-purple">
                          <el-form-item>
                            {{
                              "第" + item.number + "题：" + item.questionOption
                            }}
                            <span class="topictype">[简答题]</span>
                          </el-form-item>
                          <el-form-item label="">
                            <vxe-table
                              :data="item.data2"
                              round
                              border
                              class="mytable-scrollbar"
                              style="width: 100%"
                              ref="multipleTable"
                              empty-text="没有更多数据了！"
                              resizable
                              stripe
                            >
                              <template
                                v-for="(item, key) in Data2List"
                                :key="key"
                              >
                                <vxe-table-column
                                  v-if="item.isShow"
                                  :field="item.prop"
                                  :title="item.label"
                                  :width="item.width"
                                  align="center"
                                  :class-name="JSON.stringify(item)"
                                  :formatter="formatterData"
                                />
                              </template>
                            </vxe-table>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>

                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { GetQuestionDataDetailResultById } from "@api/Questionnaire";
// import XEUtils from "xe-utils";
import { downloadPDF } from "@/util/pdf.js"
import { dateFormat } from "@/util/utils.js";

export default {
  name: "QuestionnaireObjectSet",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    parentcode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      range: "0", //选择的维度
      CompanyData: [],
      DepartmentData: [],
      UserData: [],
      DataList: [],
      CheckedIds: [], //编辑的时候选中用
      Data1List: [
        {
          prop: "questionOptionName",
          label: "选项",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "selectCount",
          label: "选择数量",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "scale",
          label: "百分比",
          width: "300",
          format: "",
          order: false,
          isShow: true,
        },
      ],
      Data2List: [
        {
          prop: "number",
          label: "序号",
          width: "70",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "sumbitUser",
          label: "提交人",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "sumbitTime",
          label: "提交时间",
          width: "150",
          format: "",
          order: false,
          isShow: true,
        },
        {
          prop: "content",
          label: "内容",
          width: "300",
          format: "",
          order: false,
          isShow: true,
        },
      ],
      title: "问卷标题"
    };
  },
  created() {},
  mounted() {},
  methods: {
     customColorMethod (percentage) {
      if (percentage < 30) {
        return '#909399'
      }
      if (percentage < 70) {
        return '#e6a23c'
      }
      return '#67c23a'
    },
    loadDataById(id,title) {
      var _this = this;
      this.title = title
      GetQuestionDataDetailResultById(id).then((x) => {
        _this.DataList = x;
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      let name = column.property;
      switch (name) {
        case "sumbitTime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "status":
          cellValue =
            cellValue == "0" ? "未审核" : cellValue == "1" ? "已审核" : "";
          break;
      }
      return cellValue;
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("handleCancel");
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleConfirm() {
      var ids = [];
      this.$refs.multipleTable.getCheckboxRecords(true).forEach((x) => {
        ids.push(x.id);
      });

      if (ids.length == 0) {
        this.$message.error("请选择维度对象");
        return;
      }
      this.$emit("handleConfirm", {
        range: this.range,
        ids: ids,
      });
    },
    validate() {
      if (!this.SelectData.code || this.SelectData.code == "") {
        this.$message.error("代码是必须的!");
        return false;
      }
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("名称是必须的!");
        return false;
      }
      return true;
    },
    // 下载报告，pdf格式
    downloadReport(){
      let filename = this.title;
      let loading = this.GetLoading("下载中...");
      downloadPDF(this.$refs.pdf,filename).then(result => {
        loading.close();
      })
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
};
</script>

<style lang="scss" scoped >
.switch-content {
  // height: 750px;
  // overflow-y: scroll;
}
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {

  .el-button {
    min-height: 0;
    // background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    // color: #ffffff;
    padding: 12px 20px;
    // border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  // min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
  padding-left: 20px;
  padding-top: 10px;
}
.topictype {
  color: #707070;
}
.title {
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: 600;
}
</style>
